import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle, Circle } from "@phosphor-icons/react";

/**
 * Generic invoiced toggle that PATCHes { invoiced: bool } to the given endpoint.
 * Works for interventions, services, assistance-logs (any resource with the flag).
 * Purely visual — does NOT affect revenue stats.
 */
export default function GenericInvoicedToggle({
  initialInvoiced,
  patchUrl,
  testId,
  onChange,
  size = "sm",
  disabled = false,
}) {
  const [invoiced, setInvoiced] = useState(!!initialInvoiced);
  const [busy, setBusy] = useState(false);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (busy || disabled) return;
    const next = !invoiced;
    setBusy(true);
    setInvoiced(next);
    try {
      const { data } = await api.patch(patchUrl, { invoiced: next });
      onChange && onChange(data);
    } catch (err) {
      setInvoiced(!next);
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Errore");
    } finally {
      setBusy(false);
    }
  };

  const iconSize = size === "lg" ? 18 : 14;

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={busy || disabled}
      data-testid={testId}
      title={invoiced ? "Fattura emessa – clicca per revocare" : "Da fatturare – clicca quando emetti la fattura"}
      className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-full text-[10px] font-mono uppercase tracking-widest border transition-colors ${
        invoiced
          ? "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border-emerald-500/30 hover:bg-emerald-500/25"
          : "bg-muted text-muted-foreground border-border hover:bg-secondary"
      } ${busy || disabled ? "opacity-60" : ""}`}
    >
      {invoiced ? <CheckCircle size={iconSize} weight="fill" /> : <Circle size={iconSize} />}
      {invoiced ? "Fatturato" : "Da fatturare"}
    </button>
  );
}
